import { Mail, Linkedin, MapPin } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ContactInfo = () => {
  const { t } = useLanguage();

  return (
    <div 
      className="flex flex-wrap gap-3 sm:gap-4 lg:gap-5 justify-center lg:justify-start pt-3 sm:pt-4 text-muted-foreground animate-fade-in" 
      style={{ animationDelay: '0.5s' }}
    >
      <a 
        href="mailto:aurelia.ravelo@outlook.fr" 
        className="group flex items-center gap-2 sm:gap-2.5 text-xs sm:text-sm hover:text-primary transition-colors duration-300 link-glow"
      >
        <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary/8 flex items-center justify-center group-hover:bg-primary/15 dark-glow-hover transition-all duration-300">
          <Mail className="w-3.5 h-3.5 sm:w-4 sm:h-4 icon-glow" />
        </div>
        <span className="hidden sm:inline">{t("hero.contact")}</span>
        <span className="sm:hidden">Email</span>
      </a>
      <a 
        href="https://www.linkedin.com/in/aur%C3%A9lia-ravelo-a9ab15196/" 
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 sm:gap-2.5 text-xs sm:text-sm hover:text-primary transition-colors duration-300 link-glow"
      >
        <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary/8 flex items-center justify-center group-hover:bg-primary/15 dark-glow-hover transition-all duration-300">
          <Linkedin className="w-3.5 h-3.5 sm:w-4 sm:h-4 icon-glow" />
        </div>
        <span>LinkedIn</span>
      </a>
      <span className="flex items-center gap-2 sm:gap-2.5 text-xs sm:text-sm">
        <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-primary/8 flex items-center justify-center">
          <MapPin className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
        </div>
        <span>Paris</span>
      </span>
    </div>
  );
};

export default ContactInfo;
